import React, { useEffect, useState } from 'react';
import { UserService } from '../../services/user.api.client';
import { useCompany } from '../../contexts/CompanyContext';
import { useConfig } from '../../contexts/ConfigContext';
import { useUser } from '../../contexts/UserContext';
import { Permissions } from '../../models/calendar/Permissions.model';
import { useModalConfiguration } from '../../contexts/calendar/ModalConfigurationContext.context';
import { Select } from 'antd';
import { UserKeyValue } from '../modal/CreateEvent.modal';
import { User } from '../../models/calendar/User.model';


type Permission = {
  key: string;
  label: string;
  type: "view"|"actions";
};

const permissionsList: Permission[] = [
  { key: "calendar.calendars.main.view.create_calendar", label: "Crear calendario", type: "view"},
  { key: "calendar.calendars.main.options.view.edit_calendar", label: "Editar calendario", type: "view" },
  { key: "calendar.calendars.main.options.view.configuration_week", label: "Configuración de la semana", type: "view"  },
  { key: "calendar.calendars.main.options.view.delete_calendar", label: "Eliminar calendario", type: "view"  },
  { key: "calendar.calendars.main.options.view.configuration_users", label: "Configuración de usuarios", type: "view"  },
];

const UserConfigBoard: React.FC = () => {
    const [selected, setSelected] = useState<string[]>([]);
    const {company} = useCompany();
    const {user,updateUser} = useUser();
    const {config} = useConfig();
    const {options} = useModalConfiguration();
    const [loadUser,setLoadUser] = useState<boolean>(true);
    const [block,setBlock] = useState<boolean>(true);
    const [users,setUsers] = useState<UserKeyValue[]>([]);
    const [userConfig,setUserConfig] = useState<string>(user.uid);

    useEffect(()=>{
        if (!company.current.uid) return;
        setLoadUser(true);
        UserService.getPermissions(company.current.uid,userConfig).then((response)=>{
            const permissions: Permissions = response;
            setSelected(permissions.views);
        })
        UserService.getAllUsers(company.current.uid).then((response)=>{
            const usersData: any[] = response;
            const userKeyValue:UserKeyValue[] = usersData.map((user:any)=>({label:user.name,key:user.uid || user.uidUser}));
            setUsers(userKeyValue);
            
            if (userKeyValue.length > 0 && !userKeyValue.some(u => u.key === userConfig)) {
                setUserConfig(userKeyValue[0].key);
            }
            
            setLoadUser(false);
        })
    },[company.current.uid,options.isopen,userConfig])

    const togglePermission = (key: string) => {
        setSelected((prev) => {
            const safePrev = Array.isArray(prev) ? prev : [];
            return safePrev.includes(key)
            ? safePrev.filter((perm) => perm !== key)
            : [...safePrev, key];
        });
    };


    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const data = permissionsList.filter((record)=>selected.includes(record.key));
        const body:{views:string[],actions:string[]} = {
            views: data.filter((permission)=>permission.type=="view").map((record)=>record.key),
            actions: data.filter((permission)=>permission.type=="actions").map((record)=>record.key)
        }
        UserService.updatePermissions(company.current.uid,userConfig,config.key,body).then(()=>{
            if(userConfig == user.uid) updateUser({permissions:{...body}})
        })
    };

    return (
        <form
            onSubmit={handleSubmit}
            className="p-2 rounded-xl"
            >
            <h1 className="text-xl font-bold mb-4 text-gray-800">
                Gestión de Permisos de Usuario
            </h1>
            {!loadUser&&<article>
                <legend className="font-semibold text-gray-600">Usuario: </legend>
                    <input
                        type="checkbox"
                        checked={!block}
                        onChange={() => setBlock((value)=>!value)}
                        className="mr-2"
                    />
                    <Select
                        className="mt-2 w-[80%] mb-2"
                        disabled={block}
                        value={userConfig}
                        placeholder="Seleccione un Usuario"
                        onChange={(value:string)=>setUserConfig(value)}
                        >
                        {
                            users.map((userItem:UserKeyValue) => (
                                <Select.Option key={userItem.key} value={userItem.key}>
                                    <span>{userItem.label}</span>
                                </Select.Option>
                            ))
                        }
                    </Select>
            </article>}
            <fieldset className="border border-gray-300 rounded-lg px-4 pb-4">
                <legend className="font-semibold text-gray-600">Permisos de Calendario</legend>
                {permissionsList.map(({ key, label }) => (
                <label key={key} className="block mt-2">
                    <input
                    type="checkbox"
                    value={key}
                    checked={Array.isArray(selected) && selected.includes(key)}
                    onChange={() => togglePermission(key)}
                    className="mr-2"
                    />
                    {label}
                </label>
                ))}
            </fieldset>

            <div className="flex gap-2 mt-4">
                <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                >
                Guardar cambios
                </button>
                <button
                type="button"
                onClick={() => setSelected([])}
                className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
                >
                Restablecer
                </button>
            </div>
        </form>
    );
};

export default UserConfigBoard;